export default __webpack_public_path__ + "static/service-management-specialization-364079809d96eeeab564d42a2c96de81.svg";